import { useState, useCallback, useRef } from "react"
import { fetchDuesDashboard } from "../api/collectionsApi"

export function useDuesDashboard() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const abortRef = useRef(null)

  const fetch = useCallback(async (filters = {}) => {
    if (abortRef.current) abortRef.current.abort()
    abortRef.current = new AbortController()

    setLoading(true)
    setError(null)
    try {
      const result = await fetchDuesDashboard(filters)
      setData(result)
    } catch (err) {
      if (err.name !== "AbortError") setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, error, fetch, reload: fetch }
}
